import React from "react"
import strings from "../../../../localization/strings"
import { IUserDocument, ELoggedInUserType } from "../../../../models"
import AccrualsDashboard from "./AccrualsDashboard"
import LeaveRequestDashboard from "./LeaveRequestDashboard"
import moment from "moment"
interface IProps {
  user: IUserDocument
  loggedInUserType: ELoggedInUserType
  supervisorReadonlyForSelf?: boolean
}
interface IState {
  accrualDashboardHeight: number
  leaveRequestDashboardHeight: number
}

export default class SelfServiceLeaveDashboard extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      accrualDashboardHeight: 100,
      leaveRequestDashboardHeight: 160,
    }
  }

  componentDidMount() {
    const expandedDashboardHeight = document.getElementById("SelfServiceLeaveDashboard").parentElement.clientHeight - 40
    const titleAreaHeight = 60
    const leaveRequestSubmitButton = document.getElementById("LeaveRequestSubmitButton")
    const accrualDashboardHeight = Math.floor((expandedDashboardHeight - titleAreaHeight) * (leaveRequestSubmitButton ? 0.4 : 0.5))
    this.setState({
      accrualDashboardHeight,
      leaveRequestDashboardHeight: expandedDashboardHeight - titleAreaHeight - accrualDashboardHeight
    })
  }

  render() {
    const startDate = moment().subtract(1, "month")
    const endDate = moment().add(1, "year")
    const startDateUTC = startDate.utc(true).startOf("day").format()
    const endDateUTC = endDate.utc(true).endOf("day").format()
    return (
      <div style={{ textAlign: "center", paddingLeft: 20, paddingRight: 20 }} id="SelfServiceLeaveDashboard">
        <div style={{ marginBottom: 15 }}>
          <span style={{ fontSize: 20, fontWeight: 600 }}>{strings.Leave_Information}</span>
          <br />
          <span>{`${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`}</span>
        </div>
        <div style={{ marginBottom: 20 }}>
          <AccrualsDashboard
            user={this.props.user}
            loggedInUserType={this.props.loggedInUserType}
            height={this.state.accrualDashboardHeight - 20}
          />
        </div>
        <div>
          <LeaveRequestDashboard
            user={this.props.user}
            loggedInUserType={this.props.loggedInUserType}
            startDateUTC={startDateUTC}
            endDateUTC={endDateUTC}
            supervisorReadonlyForSelf={this.props.supervisorReadonlyForSelf}
            height={this.state.leaveRequestDashboardHeight}
          />
        </div>
      </div>
    )
  }
}